export const Comparators = {
  EQUAL: {
    name: 'EQUAL',
    label: 'comparators.equal',
    icon: 'glicon-equal'
  },
  LESS_THAN: {
    name: 'LESS_THAN',
    label: 'comparators.lessThan',
    icon: 'glicon-less-than'
  },
  GREATER_THAN: {
    name: 'GREATER_THAN',
    label: 'comparators.greaterThan',
    icon: 'glicon-greater-than'
  }
};